import { hdmgdjDownloadSteps } from "@/mocks/hdmgdj/download";
import { hdmgdjJumpTo } from "@/hooks/hdmgdj/useHdmgdjScroll";

export default function HdmgdjDownloadSteps() {
  const goFaq = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    hdmgdjJumpTo("hdmgdj-download-faq");
  };

  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="hdmgdj-container">
        <div className="hdmgdj-reveal max-w-2xl">
          <span className="inline-flex items-center gap-2 text-primary-700 text-[14px] font-label font-bold">
            <i className="ri-route-line text-lg" />
            安装指引
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-[30px] md:text-[38px] leading-tight">
            三步完成 黄豆魔改短剧 安装
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {hdmgdjDownloadSteps.map((step, index) => (
            <div
              key={step.id}
              className="hdmgdj-reveal relative bg-background-100 border border-background-200 rounded-lg p-6"
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <span className="absolute right-5 top-4 font-heading text-[46px] leading-none text-background-300">
                {index + 1}
              </span>
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-950 text-2xl">
                <i className={step.icon} />
              </span>
              <h3 className="mt-4 text-[17px] font-bold font-label text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-[14px] leading-7 text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="hdmgdj-reveal mt-8 bg-secondary-100 rounded-lg p-5 md:p-6 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
          <div className="flex items-start gap-3">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 text-secondary-800 text-xl shrink-0">
              <i className="ri-information-line" />
            </span>
            <div>
              <p className="text-[15px] font-bold font-label text-foreground-950">安装遇到问题？</p>
              <p className="mt-1 text-[13px] leading-6 text-foreground-700">
                请在系统设置中允许"未受信任来源"或完成开发者信任设置，即可正常安装。
              </p>
            </div>
          </div>
          <a
            href="#hdmgdj-download-faq"
            onClick={goFaq}
            className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-foreground-950 text-background-50 text-[14px] font-label font-bold whitespace-nowrap hover:bg-foreground-900 transition-colors cursor-pointer self-start sm:self-auto"
          >
            <i className="ri-question-line text-lg" />
            查看常见问题
          </a>
        </div>
      </div>
    </section>
  );
}